import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import axiosApi from "./../servicios/axios.service";
import SedeContent from "./SedeContent"; // Importa el componente SedeContent
const { DateTime } = require("luxon");
const SedesTabs = () => {
  const [sedes, setSedes] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [ultimactualizacion, setultimaactualizacion] = useState(DateTime.now());

  useEffect(() => {
    // Aquí realizamos la consulta a la API para obtener las sedes

    const fetchSedes = async () => {
      try {
        const response = await axiosApi.axiosApi.get(
          "https://api.fichajedigital.com/api/panel/listadosedes",
        );
        console.log(response);
        let data = response.data;
        // Mostrar solo la sede del usuario logueado (id_empresaSede)
        const idEmpresaSede = Number(localStorage.getItem("id_empresaSede"));
        if (idEmpresaSede) {
          data = data.filter((item) => item.id === idEmpresaSede);
        }
        data.map((item, index) => {
          if (item.nombre.startsWith("ZZZ")) {
            item.nombre = item.nombre.slice(3);
          }
        });
        setSedes(data);
        setultimaactualizacion(DateTime.now());
      } catch (error) {
        console.error("Error al obtener las sedes:", error);
      }
    };

    fetchSedes();

    // Crear un intervalo para llamar a fetchSedes cada 10 minutos (600000 ms)
    const intervalId = setInterval(fetchSedes, 60000);

    // Limpiar el intervalo cuando el componente se desmonte
    return () => clearInterval(intervalId);
  }, []);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: 2,
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
          px: 2,
          borderBottom: "1px solid #e2e6ea",
        }}
      >
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          aria-label="tabs de sedes"
          textColor="primary"
          indicatorColor="primary"
          sx={{
            "& .MuiTab-root": { fontWeight: 600, letterSpacing: ".3px" },
            "& .Mui-selected": { color: "#2f4256" },
          }}
        >
          {sedes.map((sede, index) => (
            <Tab key={sede.id} label={sede.nombre} />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ p: 3 }}>
        {sedes.map((sede, index) => (
          <div
            role="tabpanel"
            hidden={selectedTab !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            key={sede.id}
          >
            {selectedTab === index && (
              <SedeContent
                ultimactualizacion={ultimactualizacion}
                sedeId={sede.id}
                sedes={sedes}
              /> /* Renderiza el componente SedeContent */
            )}
          </div>
        ))}
      </Box>
    </Box>
  );
};

export default SedesTabs;
